export const isIE = () => {
  const ua = navigator.userAgent.toUpperCase();
  return ua.match(/MSIE/) != null || ua.match(/TRIDENT/) != null || /*@cc_on!@*/ false || !!document.documentMode;
};

export const isEdge = () => {
  const ua = navigator.userAgent.toUpperCase();
  return ua.match(/EDGE/) != null || (!isIE && !!window.StyleMedia);
};
